import { RISK_RULES, RISK_INDICATORS } from '@silverfort-nodelibs/common/utils/insight';
import { Icons } from '@silverfort/sf-components';

const RISK_TO_ICON = {
    [RISK_RULES.ADMIN_WITH_SPN]: Icons.AdminWithSPN,
    [RISK_RULES.AZURE_SHADOW_ADMIN]: Icons.AzureShadowAdmin,
    [RISK_RULES.NON_ADMIN_DC_OWNER]: Icons.DomainControllersWithNonAdminOwners,
    [RISK_RULES.FAILED_AUTHS_BATCH]: Icons.FailedAuthenticationsBatches,
    [RISK_RULES.NTLM_V1]: Icons.NTLMV1Authentication,
    [RISK_RULES.NTLM_V2]: Icons.NTLMV1Authentication,
    [RISK_RULES.PASSWORD_NEVER_EXPIRES]: Icons.PasswordNotExpired,
    [RISK_RULES.PRINT_NIGHTMARE_FIX]: Icons.PrinterNightmare,
    [RISK_RULES.SHADOW_ADMIN]: Icons.ShadowAdmin,
    [RISK_RULES.STALE_USER]: Icons.StaleUser,
    [RISK_RULES.UNCONSTRAINED_DELEGATION_USER]: Icons.UnconstrainedDelegation,
    [RISK_RULES.OLD_PASSWORD]: Icons.PasswordOld,
    [RISK_RULES.SERVER_WEAK_ENCRYPTION]: Icons.WeakEncryptionServer,
    [RISK_RULES.USER_WEAK_ENCRYPTION]: Icons.WeakEncryptionUser,
    [RISK_RULES.RODC_PRIVILEGED_CREDENTIALS]: Icons.PrivilegedUser,
    [RISK_RULES.AZURE_PRIVILEGED_GUEST]: Icons.AzurePrivilegedGuests,
    [RISK_RULES.LDAP_WEAK_CIPHER]: Icons.WeakEncryption,
    [RISK_RULES.UNPRIVILEGED_CERTIFICATE_TEMPLATE_MODIFIER]: Icons.ADCS,
    [RISK_RULES.DOMAIN_ADMIN]: Icons.DomainAdmin,
    [RISK_RULES.PRIVILEGED_USER]: Icons.PrivilegedUser,
    [RISK_RULES.LOCKED_USER]: Icons.LockedAccount,
    [RISK_RULES.LOCKED_AFTER_PASSWORD_CHANGE]: Icons.PasswordLockedAfterChange,
    [RISK_RULES.SHARED_DEVICE]: Icons.ShareDevices,
    [RISK_RULES.SHARED_USER]: Icons.ShareDevices,
    [RISK_RULES.DC_OWNED_BY_NON_ADMIN]: Icons.DomainControllersWithNonAdminOwners,
    [RISK_RULES.WEAK_ENCRYPTION]: Icons.WeakEncryption,
    [RISK_RULES.STALE_RESOURCE]: Icons.StaleDevices,
    [RISK_RULES.MIXED_SESSION_HOST]: Icons.HostWithPrivilegePath,
    [RISK_RULES.OLD_OS]: Icons.OldOperatingSystem,
    [RISK_RULES.DONT_REQUIRE_PREAUTH]: Icons.KerberosDontRequirePreAuth,
    [RISK_RULES.PASSWORD_NOT_REQUIRED]: Icons.PasswordNotRequired,
    [RISK_RULES.LEAKED_CREDENTIALS]: Icons.LeakedCredentials,
    [RISK_RULES.PRIVILEGED_COMPUTER]: Icons.PrivilegedComputer,
    [RISK_RULES.USER_WITH_SPN]: Icons.UsersWithSPN,
    [RISK_RULES.UNPRIVILEGED_DNS_ADMIN]: Icons.UnprivilegedDNSAdmin,
    [RISK_RULES.STALE_USER]: Icons.StaleUser,
    [RISK_RULES.STALE_RESOURCE]: Icons.StaleDevices,
    [RISK_RULES.STALE_DOMAIN_CONTROLLER]: Icons.StaleDomainControllers,
    [RISK_RULES.PRIVILEGED_USER_NOT_IN_PROTECTED_USERS_GROUP]: Icons.PrivilegedUserNotInProtectedUsersGroup,
    [RISK_RULES.ENTRA_ID_SYNCED_ADMIN]: Icons.SyncdAdmin,
    [RISK_RULES.USER_PASSWORD_EXPOSED]: Icons.UsersPasswordExposed,
    [RISK_RULES.DOMAIN_CONTROLLER_OLD_PASSWORD]: Icons.DomainControllersWithOldPasswords,
};

export const RISKS_FOR_INSIGHTS_TABLE = new Set(
    Object.values(RISK_INDICATORS)
        .filter((riskIndicator) => riskIndicator.isPostureInsight)
        .flatMap((riskIndicator) => riskIndicator.riskRules)
);

export const getRiskIcon = (risk: string) => {
    return RISK_TO_ICON[risk] ?? Icons.Siren;
};

export const INVENTORY_DOMAIN_ITEMS = new Set([
    'users',
    'synced_users',
    RISK_RULES.DOMAIN_ADMIN,
    'groups',
    'ous',
    RISK_RULES.PRIVILEGED_USER,
    'servers',
    'domains',
    RISK_RULES.ENTRA_ID_ADMIN
]);

export const INVENTORY_ENTRA_ITEMS = new Set(['users', 'synced_users', 'azureapps', 'tenants']);
